import UI_Layout from "../../layout/ui-layout";
import {MainMenuBackground, NavigationBackground, SkinTheme, UIType} from "../@const";
import {GoodDayUserInterface} from "../ui";
import UIModern_NavigationPanel_User from "./navigation/user";


export class GoodDayModern extends GoodDayUserInterface {

    constructor() {
        super({
            type        : UIType.GOODDAY_MODERN
        })
    }

    get isMinimizeMenuAllowed(): boolean {
        return false
    }

    get layoutCSSClass():string {
        return "ui-layout left-nav"
    }

    get LayoutClass() {
        return UI_Layout
    }

    get NavigationPanelUserComponent():any {
        return UIModern_NavigationPanel_User
    }

    get navigationPanelMainClass() {

        let classes = "ui-navigation modern-nav"

        if (gd.user.settings.skin.showNavbarLabels) {
            classes += " has-labels"
        }

        let navigationColorTheme : NavigationBackground = gd.user.settings.skin.navigation

        switch (gd.skin.layoutTheme) {
            case SkinTheme.DARK:
                // patch for dark ?
                // if (navigationColorTheme==='white' || theme==='gray') theme = NavigationBackground.DARK   // no white or gray in dark mode
                classes += ' theme-dark-'+ navigationColorTheme
                break

            case SkinTheme.LIGHT:
            default:
                classes += ' theme-light-'+ navigationColorTheme
                break
        }

        return classes
    }

    get uiLeftMenuThemeClass() {

        if (gd.user.settings.skin.menu === MainMenuBackground.PALE ) {

            return "pale-bg " + gd.user.settings.skin.navigation

        } else {
            let menuThemeClass = 'theme-'+gd.user.settings.skin.menu

            if (gd.skin.layoutTheme === 'dark') {
                menuThemeClass = "theme-dark-skin"
            }

            return menuThemeClass
        }
    }

    get leftNavigationPanelSize(): number {
        return 70 // 54 navbar width + 16 left and right space of navbar
    }

    get navbarButtonSize() {

        if (gd.user.settings.skin.showNavbarLabels) {
            return 62
        } else {
            return 44
        }

    }

    get uiCenterLeftSpace(): number {
        return this.leftNavigationPanelSize
    }

    get uiCenterLeftSideDifference(): number {
        // return this.leftNavigationPanelSize + 10
        return this.uiCenterLeftSpace + 8
    }

    get uiCenterMainClass() {

        if (gd.user.settings.skin.menu === MainMenuBackground.PALE ) {
            return 'ui-center-goodday-modern pale-bg'
        } else {
            return 'ui-center-goodday-modern'
        }

    }

    get moreLabel(): string {
        return "More"
    }

}
